function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M896 256H682.667v-71.253A103.253 103.253 0 00576 85.333H448a103.253 103.253 0 00-106.667 99.414V256H128a42.667 42.667 0 000 85.333h42.667v469.334a128 128 0 00128 128h426.666a128 128 0 00128-128V341.333H896A42.667 42.667 0 00896 256zm-469.333-71.253c0-6.827 8.96-14.08 21.333-14.08h128c12.373 0 21.333 7.253 21.333 14.08V256H426.667z",
  fill: "#231F20"
})));